<template>
    <VJoyPanel>
        <template #panel-title>
            {{ $t('projectclient.projectview.details.freelancer-description.title') }}
        </template>
        <template #panel-body>
            <div class="project-details-freelancer-description">
                <ShowMoreTextContent :lines="3">
                    <template #text-content>
                        <div v-if="projectInformation.contract.descriptionFormat === 'MARKDOWN'" v-html="freelancerDescription"></div>
                        <div v-else>{{ freelancerDescription }}</div>
                    </template>
                </ShowMoreTextContent>
            </div>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {escapeHtml} from '@malt/sanitize';
    import {VJoyPanel} from '@maltjoy/core-vue';
    import {useProjectInformationStore} from '@/common/stores';
    import {ShowMoreTextContent} from '@/common/ui';
    import {useMarkdownToHtml} from '@/common/utils';

    const {markdownToHtml} = useMarkdownToHtml();
    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);

    const freelancerDescription = computed(() => {
        if (projectInformation.value.contract.descriptionFormat === 'MARKDOWN') {
            return markdownToHtml(projectInformation.value.contract.description) ?? '-';
        } else {
            return escapeHtml(projectInformation.value.contract.description);
        }
    });
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    .project-details-freelancer-description {
        @include joy.getFontBySize(primary-300);
    }
</style>
